import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** @jsx jsx */
import { render, createPortal } from '@wordpress/element';
import { useEffect, useState } from 'react';
import MapPopup from './components/MapPopUp';
import ProjectsList from './components/ProjectsList';
import SearchEngine from './components/SearchEngine';
import "./style/global.scss";
import theme from './theme/muiTheme';
import { ThemeProvider } from '@mui/material/styles';
const App = (props) => {
    const [showProjectList, setShowProjectList] = useState(false);
    const [projects, setProjects] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    function handleProjectListDisplay(showProjectList) {
        var _a, _b;
        setShowProjectList(showProjectList);
        showProjectList ? (_a = document.getElementById("arcgismap_container")) === null || _a === void 0 ? void 0 : _a.style.display = "none" : (_b = document.getElementById("arcgismap_container")) === null || _b === void 0 ? void 0 : _b.style.display = "flex";
    }
    function handleProjectListChange(projects) {
        setProjects(projects);
    }
    function handleClosePopupClick() {
        var _a;
        (_a = document.getElementById('map-popup')) === null || _a === void 0 ? void 0 : _a.remove();
        props.mapInterface.clearHighlight();
    }
    useEffect(() => {
        window.addEventListener('features_clicked', (e) => {
            if (e.detail) {
                setSelectedProjects(prevState => (e.detail.features));
            }
        }, false);
    }, []);
    useEffect(() => {
        var _a;
        if (selectedProjects && selectedProjects.length !== 0) {
            (_a = document.getElementById('map-popup')) === null || _a === void 0 ? void 0 : _a.remove();
            // Used to append popup in parent div (arcgismap_container) instead of replacing the content (aka the webmap)
            const arcgismap_container = document.getElementById('arcgismap_container');
            arcgismap_container && render(createPortal(_jsx(MapPopup, { projects: selectedProjects, closePopupClick: handleClosePopupClick }), arcgismap_container), document.createElement('div'));
        }
    }, [selectedProjects]);
    return (_jsxs("div", Object.assign({ id: "react-container" }, { children: [_jsx(SearchEngine, { handleProjectListDisplayCB: handleProjectListDisplay, handleProjectListChangeCB: handleProjectListChange, handleClosePopupClickCB: handleClosePopupClick, mapInterface: props.mapInterface, showProjectList: showProjectList }), (() => {
                if (!showProjectList) {
                    return (_jsx("div", {}));
                }
                else {
                    return (_jsx(ProjectsList, { projects: projects }));
                }
            })()] })));
};
window.addEventListener('arcgis_webmap_loaded', () => {
    render(_jsx(ThemeProvider, Object.assign({ theme: theme }, { children: _jsx(App, { mapInterface: window.som_map_interface }) })), document.getElementById('react-app-container'));
}, false);
